import { SelectionModel } from '@angular/cdk/collections';
import { Component, ViewEncapsulation } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ICustomResponse } from 'cloud-shared-lib';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CadModelMaterialsMatchingService } from '../cadmodel-materials-matching.service';

@Component({
  selector: 'cutting-mat-base-slots-dialog',
  templateUrl: './mat-base-slots-dialog.component.html',
  styleUrls: ['./mat-base-slots-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MatBaseSlotsDialogComponent {
  selection: SelectionModel<number> = new SelectionModel<number>(false, []);
  displayedColumns = ['select', 'name'];
  dataSourceSlots: MatTableDataSource<string> = new MatTableDataSource();
  data$: Observable<ICustomResponse<string[]>>;

  constructor(
    public dialogRef: MatDialogRef<MatBaseSlotsDialogComponent>,
    private cadModelMaterialMatchingService: CadModelMaterialsMatchingService
  ) {
    this.data$ = this.cadModelMaterialMatchingService
      .getMateBaseSlots()
      .pipe(tap(res => (this.dataSourceSlots.data = res.result)));
  }
}
